<template>
	<div class="volunteer-home-online-training">
		<div class="online-training-box">
			<div class="ss-type-box">
				<div class="ss-type__label">
					<img src="~@/assets/img/volunteerHome/xm-type.png" />
					项目状态
				</div>
				<div class="ss-type__text">
					<span v-for="(item, index) in stateList" @click="changeState(index)" :class="{'active': stateIndex === index}" :key="item.value">{{item.label}}</span>
				</div>
			</div>
			<div class="mt40">
				<ssTrainList :finish="finish_" :busy="busy_" :value="curData_" detailPath="/volunteerHome/project/" />
			</div>
		</div>
		<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
	</div>
</template>

<script>
	import ssTrainList from '@/components/ss-train-list/ss-train-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		components: {
			ssTrainList
		},
		data() {
			return {
        stateList: [{
					label: '招募中',
					value: '1'
				}, {
					label: '已结项',
					value: '4'
				}],typeList: [{
					label: '志愿项目',
					value: 'zyxm'
				}],
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.volunteer-home-online-training{
		.online-training-type{
			li{
				display: inline-block;
				font-size:16px;
				font-family:Source Han Sans CN;
				font-weight:400;
				color:rgba(162,163,162,1);
				line-height:28px;
				margin-right: 90px;
				&.active{
					color: #0260FE;
					border-bottom: 3px solid #0260FE;
				}
			}
		}
		.online-training-box{
			background-color: #fff;
			padding: 30px 35px;
			::v-deep .train-list{
				padding-right: 60px;
				.train-item{
					margin-right: 30px;
					width: 33.33333333%;
					&:nth-of-type(4n) {
						float: left;
						margin-right: 30px;
					}
					&:nth-of-type(3n) {
						float: right;
						margin-right: -60px;
					}
				}
			}
		}
	}
</style>
